// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-enter-active[data-v-7df13924],\n.list-leave-active[data-v-7df13924] {\n  transition: transform 1s;\n}\n.list-enter-from[data-v-7df13924],\n.list-leave-to[data-v-7df13924] {\n  opacity: 0;\n}", ""]);
// Exports
module.exports = exports;
